<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 15:02:05
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimTypePropertyGroup\viewClaimTypePropertyGroup.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_ClaimTypePropertyGroup_form_editTitle')
        : $t('label_essweb_ClaimTypePropertyGroup_form_viewTitle')
    "
    widthClass="max-1000"
    pad="0"
    :delBtn="hasBtn('delete-claim-type-property-group')"
    :initData="claimTypeGroupData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'claim_type_property_group_name',
      'claim_type_property_group_description',
      'claim_type_property_group_code',
      'remarks',
    ]"
    :editBtn="!iSEdited && hasBtn('edit-claim-type-property-group')"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_ClaimTypePropertyGroup_list_title')).then(
        (res) => {
          res ? toDelete() : null;
        }
      )
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <Taber :curTab="curTab" @change="(tab) => (curTab = tab)" :items="taber">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="claimTypeGroupData.claim_type_property_group_name"
                  @change="
                    (valueArr) => {
                      claimTypeGroupData.claim_type_property_group_name =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_ClaimTypePropertyGroup_form_groupNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :filled="iSEdited"
                  :readonly="!iSEdited"
                  :bindData="
                    claimTypeGroupData.claim_type_property_group_description
                  "
                  @change="
                    (valueArr) => {
                      claimTypeGroupData.claim_type_property_group_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_ClaimTypePropertyGroup_form_descriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :filled="iSEdited"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :readonly="!iSEdited"
                  :label="
                    $t('label_essweb_ClaimTypePropertyGroup_form_codeLabel')
                  "
                  v-model="claimTypeGroupData.claim_type_property_group_code"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_ClaimTypePropertyGroup_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="3"
                  no-resize
                  maxlength="150"
                  dense
                  :filled="iSEdited"
                  counter="150"
                  single-line
                  :readonly="!iSEdited"
                  v-model="claimTypeGroupData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <PropertyList
            :items="desserts"
            :listdata="PropertyListData"
            @edit="
              (obj) => {
                viewProperty = false;
                toEditProperty(obj);
              }
            "
            @view="
              (obj) => {
                viewProperty = true;
                toEditProperty(obj);
              }
            "
            :canEdit="iSEdited"
          />
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <EditMappingPopup6
        :show="showMappingPopup"
        :PropertyData="PropertyData"
        :curGroupId="$route.params.id"
        :view="viewProperty"
        @close="
          showMappingPopup = false;
          PropertyData = null;
        "
        @confirm="onEditProperty"
      />
    </template>
  </ContentLayout>
</template>
<script>
import EditMappingPopup6 from "@/Page/EssAdmin/Claim/ClaimTypePropertyGroup/components/EditMappingPopup6.vue";
import { mapGetters } from "vuex";
export default {
  name: "editClaimTypePropertyGroup",
  components: { EditMappingPopup6 },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  data() {
    return {
      iSEdited: false,
      isChanged: false,
      PropertyData: null,
      PropertyListData: null,
      showMappingPopup: false,
      curTab: "tab-1",
      taber: [
        "label_essweb_ClaimTypePropertyGroup_leaveTransactionPropertyGroup_form_step_generalLabel",
        "label_essweb_ClaimTypePropertyGroup_form_step_propertyGroupLabel",
      ],
      mapToDialog: false,
      mapToEditDialog: false,
      viewProperty: false,
      curProperty: null,
      page: 1,
      showSelect: false,
      claimTypeGroupData: {
        claim_type_property_group_name: "",
        claim_type_property_group_description: "",
        claim_type_property_group_code: "",
        remarks: "",
      },
      curCategory: [],
      curPropertyId: null,
      showPGDelete: false,
      desserts: [],
      curUuids: [],
    };
  },
  watch: {},
  mounted() {
    // this.claimTypeGroupData.claim_type_property_group_name = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.claimTypeGroupData.claim_type_property_group_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getBtnPermissionList();
    this.getGroupDetail();
    this.getPorpertyList();
  },
  methods: {
    getGroupDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_property_group",
        url: "/claim-type-property-group/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["claim_type_property_group_name_save"] =
          res.data.claim_type_property_group_name;
        res.data.claim_type_property_group_name =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.claim_type_property_group_name
          );
        res.data["claim_type_property_group_description_save"] =
          res.data.claim_type_property_group_description;
        res.data.claim_type_property_group_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.claim_type_property_group_description
          );
        that.claimTypeGroupData = res.data;
      });
    },
    toEditProperty: function (obj) {
      this.PropertyData = obj;
      this.showMappingPopup = true;
    },
    onEditProperty: function (obj, deleteArr, changeList) {
      const that = this;
      this.PropertyData = null;
      // obj["changeList"].map((item) => (item["org_level_uuid"] = "002"));
      that.showMappingPopup = false;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_property",
        url: "/claim-type-property/update/",
        data: {
          uuid: this.$route.params.id,
          property_ids: deleteArr.length ? deleteArr.join(",") : "",
          ess_clm_claim_type_property: changeList,
        },
      }).then((res) => {
        that.findTreeItem(that.desserts, obj.property_master_code, changeList);
      });
    },
    findTreeItem: function (tree, code, obj) {
      const that = this;
      tree.some((item) => {
        if (item["property_master_code"] === code) {
          item["changeList"] = obj;
          if (item["changeList"].length == 0) {
            item["value"] = "";
          }
          return true;
        } else {
          if (item.children) {
            that.findTreeItem(item.children, code, obj);
          } else {
          }
        }
      });
    },
    getPorpertyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_property",
        url: "/claim-type-property/get-list/",
        data: {
          claim_type_property_group_uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data.forEach((item) => {
          item["changeList"] = [];
          item["property_master_code"] = item.claim_type_property_master_code;
          if (item.property_master_code.indexOf("|") != -1) {
            item["p_property_master_code"] =
              item.property_master_code.substring(
                0,
                item.property_master_code.lastIndexOf("|")
              );
          }
        });
        that.PropertyListData = res.data;
        that.desserts = that.$translateDataToTree(
          res.data,
          "property_master_code",
          "p_property_master_code"
        );
      });
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getGroupDetail();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getGroupDetail();
        } else {
          this.$router.back();
        }
      }
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_property_group",
        url: "/claim-type-property-group/update/",
        data: {
          uuid: this.$route.params.id,
          claim_type_property_group_name: this.$transCommonLangKey(
            this.claimTypeGroupData.claim_type_property_group_name,
            this.claimTypeGroupData.claim_type_property_group_name_save
          ),
          claim_type_property_group_description: this.$transCommonLangKey(
            this.claimTypeGroupData.claim_type_property_group_description,
            this.claimTypeGroupData.claim_type_property_group_description_save
          ),
          claim_type_property_group_code:
            this.claimTypeGroupData.claim_type_property_group_code,
          remarks: this.claimTypeGroupData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t("message_essweb_snckbar_actionSuccessLabel"),
          type: "success",
        });
        that.toBack();
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type_property_group",
        url: "/claim-type-property-group/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          color: "success",
          text: that.$t("message_essweb_system_operation_sucess_deleteLabel"),
          type: "success",
        });
        that.toBack();
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
